module.exports = __webpack_public_path__ + "img/ur3_feature_01.720ffa19.jpg";